import { render, staticRenderFns } from "./MyConnections.vue?vue&type=template&id=b4b6f8c2"
import script from "./MyConnections.vue?vue&type=script&lang=js"
export * from "./MyConnections.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports